import { motion } from 'framer-motion'

interface Props {
  text: string
}

export default function AgentTextLine({ text }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.15 }}
      className="py-0.5 pl-1"
    >
      <span className="font-mono text-sm text-slate-400">{text}</span>
    </motion.div>
  )
}
